// extracted by mini-css-extract-plugin
module.exports = {"root":"UserIcon_root__1FyB6","gold":"UserIcon_gold__3-Toz","imageWithMask":"UserIcon_imageWithMask__29ruN"};